/* eslint-disable jsx-a11y/label-has-associated-control */

import React from "react";
import { useContext } from "../../../context";
import { displayName } from "../../../../../../../../../Utils";

export function BookedBy() {
  const { appointment } = useContext();

  return (
    <div className="detail-row">
      <label>Booked by:</label>
      <span>
        {appointment.booking?.bookedBy === "staff" &&
          displayName(appointment.booking?.user)}
        {appointment.booking?.bookedBy === "patient" && "Customer"}
      </span>
    </div>
  );
}
